var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questionnaires
    ? _c(
        "div",
        {
          staticClass: "pl-lg-2 ml-lg-2 mt-4 mt-lg-0",
          staticStyle: { "transition-delay": "0s" }
        },
        [
          _c("h3", { staticClass: "mt-lg-0" }, [
            _vm._v(
              "Latest " +
                _vm._s(_vm.is_vote === 1 ? "Vote" : "Survey") +
                _vm._s(_vm.questionnaires.length > 1 ? "s" : "")
            )
          ]),
          _vm._v(" "),
          _vm.questionnaires.length > 0
            ? _c(
                "div",
                _vm._l(_vm.questionnaires, function(questionnaire) {
                  return _c(
                    "section",
                    {
                      key: "questionnaire_" + questionnaire.userid,
                      staticClass:
                        "question container text-left p-0 col-12 mb-0 mt-4",
                      class: _vm.is_vote ? "mb-4" : ""
                    },
                    [
                      [
                        _vm.is_vote !== 1
                          ? _c("div", { staticClass: "card-header" }, [
                              _c("i", {
                                staticClass: "float-right",
                                class: questionnaire.is_anonymous
                                  ? "anonymous fas fa-user-secret"
                                  : ""
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(questionnaire.name) +
                                  "\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.is_vote === 1
                          ? _c(
                              "div",
                              { staticClass: "card-body row" },
                              [
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-up" } },
                                  _vm._l(questionnaire.questions, function(
                                    questions
                                  ) {
                                    return !_vm.completed.includes(questions.id)
                                      ? _c(
                                          "div",
                                          {
                                            key: "questions" + questions.id,
                                            staticClass:
                                              "col-12 col-lg mb-lg-0",
                                            attrs: { id: "q_" + questions.id }
                                          },
                                          [
                                            _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "font-italic font-weight-light"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(questions.question)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "row mt-3" },
                                              _vm._l(
                                                questions.options,
                                                function(options) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-6 mt-3",
                                                      class:
                                                        _vm.maxOptionLength > 30
                                                          ? "col-12"
                                                          : ""
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "options btn w-100 py-1",
                                                          class:
                                                            _vm.answered &&
                                                            _vm.answered.includes(
                                                              options.id
                                                            )
                                                              ? "btn-primary"
                                                              : "btn-light",
                                                          attrs: {
                                                            rel:
                                                              "a_" + options.id,
                                                            id:
                                                              "a_" + options.id
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.saveResponse(
                                                                {
                                                                  questionnaire_id:
                                                                    questionnaire.id,
                                                                  question_id:
                                                                    questions.id,
                                                                  answered: options
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          options.option != null
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    options.option
                                                                  )
                                                                )
                                                              ])
                                                            : _c("img", {
                                                                staticClass:
                                                                  "option_icon",
                                                                attrs: {
                                                                  src: require("@/assets/icons/" +
                                                                    options.questionnaire_icon),
                                                                  alt:
                                                                    options.alt_text
                                                                }
                                                              })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c("hr"),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "row pt-1" },
                                              [
                                                _vm.is_vote === 1
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "col-6" },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn noThanksButton col-12",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.saveResponse(
                                                                  {
                                                                    questionnaire_id:
                                                                      questionnaire.id,
                                                                    question_id:
                                                                      questions.id,
                                                                    answered: {
                                                                      id: null
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Don't Participate"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-6" },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary col-12",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.postResponse(
                                                              questionnaire.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Save Answer")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "col-12",
                                            staticStyle: {
                                              "transition-delay": "0.4s"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-success mb-0 text-center"
                                              },
                                              [
                                                _vm.answered
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "You have answered this question "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "far fa-thumbs-up"
                                                      })
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "You have chosen not to answer."
                                                      )
                                                    ])
                                              ]
                                            )
                                          ]
                                        )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          : _c("div", { staticClass: "card-body row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg mb-lg-0" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "This survey has " +
                                        _vm._s(questionnaire.questions.length) +
                                        " questions "
                                    ),
                                    questionnaire.is_anonymous
                                      ? _c("span", [
                                          _vm._v("and is "),
                                          _c("b", [_vm._v("Anonymous")])
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary mb-0 mt-1 p-3 w-100",
                                      on: {
                                        click: function($event) {
                                          return _vm.openQuestionnaire(
                                            questionnaire
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Click here to take it.\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                      ]
                    ],
                    2
                  )
                }),
                0
              )
            : _c(
                "section",
                {
                  staticClass:
                    "col-12 card container text-left p-0 mb-4 mt-4 no-surveys"
                },
                [
                  _c("div", { staticClass: "card-body text-center" }, [
                    _c("h5", { staticClass: "text-center w-100 p-0 m-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm.is_vote === 1
                            ? _vm.no_votes_text
                            : _vm.no_survey_text
                        )
                      )
                    ])
                  ])
                ]
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3041c540", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3041c540","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questionnaires.vue
// module id = null
// module chunks = 